import React from 'react';
import devwarning from '../_utils/devwarning';
var warningFunc = function warningFunc() {
  devwarning(false, 'Form', 'Can not find FormContext. Please make sure you wrap Field under Form.');
};
var context = /*#__PURE__*/React.createContext({
  getFieldError: warningFunc,
  getFieldsError: warningFunc,
  getFieldsValue: warningFunc,
  getDefaultValue: warningFunc,
  getFieldValue: warningFunc,
  resetFields: warningFunc,
  setFieldsValue: warningFunc,
  setFieldValue: warningFunc,
  submit: warningFunc,
  validateFields: warningFunc,
  getInternalHooks: function getInternalHooks() {
    warningFunc();
    return {
      dispatch: warningFunc,
      setDefaultValues: warningFunc,
      registerField: warningFunc,
      deleteField: warningFunc,
      setCallbacks: warningFunc
    };
  }
});
export default context;